import { render } from "./AuthShell.vue?vue&type=template&id=ca98e652"
import script from "./AuthShell.vue?vue&type=script&lang=js"
export * from "./AuthShell.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__